import { StandaloneAppErrorData } from '@dadohr/shared/domainTypes/internalAlerts';
import * as ENV from '../../env.json';

export const sendEmployeeAppErrorAlert = (data: StandaloneAppErrorData) => {
  const u = new URL(ENV.domains.cf.public);
  const d = btoa(JSON.stringify(data, null, 0));
  u.pathname = '/internalAlerts_reportEmployeeAppError';
  u.searchParams.set('d', d);
  fetch(u.toString());
};
